<template>
    <div class='container_box' v-if="BinfoToast" @click="close">
        <div class="content_box" @click.stop="normal">
            <div class="title">信息填写弹窗</div>
            <div class="input_group">
                <input type="text" v-model="uname" placeholder="请填写您的姓名">
                <input type="text" v-model="uphone" placeholder="请填写您的手机号" :maxlength="11">
            </div>
            <div class="btn flc" @click="accept">确认接受邀请</div>
        </div>
        <div class="colseImg positionc" @click="close">
            <img src="@/assets/images/user/talk/delete.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
            uname:'',// 用户姓名
            uphone:'',// 用户电话
        }
    },
    props:{
        BinfoToast:{
            type:Boolean,
            default:false
        }
    },
    methods :{
        // 防止冒泡点击的函数
        normal () {},
        // 点击空白处或者点击图片触发的函数
        close () {
            this.$emit("update:BinfoToast",false)
        },
        // 点击接受邀请出发的函数
        accept () {
            const reg = /^[1][3,4,5,7,8,6][0-9]{9}$/;
            if (!this.uname) {
                this.$toast('姓名不可为空')
            } else if ((!reg.test(this.uphone)) && this.uphone != '') {
                this.$toast('请输入正确的手机号')
            } else {
                this.$emit('acceptOk',{name:this.uname,phone:this.uphone})
                this.close()
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}
.positionc {
    left: 50%;
    transform: translate(-50%);
}
.container_box {
    z-index: 1000;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    .colseImg {
        width: 48px;
        height: 48px;
        position: absolute;
        top: 930px;
        img {
            width: 48px;
            height: 48px;
        }
    }
    .content_box {
        padding: 0 32px 64px;
        box-sizing: border-box;
        width: 476px;
        height: 546px;
        background: #FFFFFF;
        border-radius: 16px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: 24.6%;
        .title {
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2B2B2B;
            margin-top: 32px;
        }
        .input_group {
            margin-top: 26px;
            input {
                margin-top: 24px;
                padding: 22px 24px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #585757;
                width: 100%;
                background: #F7F7F7;
                border-radius: 8px;
                &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                    color: #A5A5A5;
                }
                &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                    color: #A5A5A5;
                }
                &::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: #A5A5A5;
                }
                &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                    color: #A5A5A5;
                }
            }
        }
        .btn {
            width: 304px;
            height: 88px;
            background: #318544;
            box-shadow: 0px 4px 8px 0px rgba(49, 133, 68, 0.27);
            border-radius: 44px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin: 80px auto 0;
        }
    }
}
</style>